export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";

export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT_FAILED = "LOGOUT_FAILED";
export const SIGNUP_FAILED = "SIGNUP_FAILED";
